import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxBootstrapConfirmComponent } from './ngx-bootstrap-confirm.component';
import { NgxBootstrapConfirmConfig } from './NgxBootstrapConfirmConfig';
@Injectable()
export class NgxBootstrapConfirmService {
  modalRef: BsModalRef;
  constructor(private modalService: BsModalService) {}

  confirm(options: NgxBootstrapConfirmConfig): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.modalRef = this.modalService.show(NgxBootstrapConfirmComponent);
      this.modalRef.content.title = options.title;
      this.modalRef.content.confirmLabel = options.confirmLabel;
      this.modalRef.content.declineLabel = options.declineLabel;
      if (options.confirmButtonClasses) {
        this.modalRef.content.confirmButtonClasses = options.confirmButtonClasses;
      }
      if (options.declineButtonClasses) {
        this.modalRef.content.declineButtonClasses = options.declineButtonClasses;
      }
      this.modalRef.content.onClose.subscribe((result: boolean) => {
        resolve(result);
      });
    });
  }
}
